import GameSetupWizard from '@/components/Room/GameSetupWizard/GameSetupWizard'

const GameSetupWizardScreen = () => {
  return <GameSetupWizard />
}

export default GameSetupWizardScreen
